import Vue from 'vue'
import { generateSetChild } from '@/helpers/VuexHelpers'

export default {
	setBrands: generateSetChild("brands"),
	setBrandsLoaded: generateSetChild("brandsLoaded"),
	setInitialized: generateSetChild("initialized"),
	setShopArea: generateSetChild("shopArea"),
	setGeolocation: generateSetChild("geolocation"),
	setMaintenanceMode: generateSetChild("maintenanceMode"),
}

